export const KEYMAP_SCHEMA = 'com.chamii.vibokey/keymap/v1'
export const MACRO_SCHEMA = 'com.chamii.vibokey/macro/v1'

export const PHYSICAL_KEYS = [
  { id: 'K1', label: 'K1', hint: '主键 1' },
  { id: 'K2', label: 'K2', hint: '主键 2' },
  { id: 'K3', label: 'K3', hint: '主键 3' },
  { id: 'K4', label: 'K4', hint: '主键 4' },
  { id: 'K5', label: 'K5', hint: '主键 5' },
  { id: 'K6', label: 'K6', hint: '主键 6' },
  { id: 'ENC1_CW', label: '旋钮 +', hint: '顺时针' },
  { id: 'ENC1_CCW', label: '旋钮 −', hint: '逆时针' },
  { id: 'ENC1_PRESS', label: '旋钮按下', hint: '按压' },
]

export const ACTION_TYPES = [
  { id: 'combo', label: '快捷键' },
  { id: 'text', label: '输入文字' },
  { id: 'media', label: '媒体控制' },
  { id: 'macro', label: '宏' },
]

export const MEDIA_ACTIONS = ['volume_up', 'volume_down', 'play_pause', 'next_track', 'previous_track', 'mute']

export function createEmptyMacro() {
  return { schema: MACRO_SCHEMA, name: '新宏', steps: [{ op: 'combo', modifiers: [], key: 'A' }] }
}

export function createDefaultKeymap() {
  return Object.fromEntries(PHYSICAL_KEYS.map((key) => [key.id, { type: 'combo', modifiers: [], key: 'A' }]))
}

function cleanString(value, max = 300) {
  return typeof value === 'string' ? value.trim().slice(0, max) : ''
}

function cleanModifiers(value) {
  const allowed = new Set(['ctrl', 'shift', 'alt', 'meta'])
  return Array.isArray(value) ? [...new Set(value.filter((item) => allowed.has(item)))] : []
}

export function normalizeStep(value) {
  const step = value && typeof value === 'object' ? value : {}
  if (step.op === 'text') return { op: 'text', value: cleanString(step.value) }
  if (step.op === 'delay') {
    const ms = Number(step.ms)
    return { op: 'delay', ms: Number.isFinite(ms) ? Math.max(10, Math.min(10_000, Math.round(ms))) : 50 }
  }
  return { op: 'combo', modifiers: cleanModifiers(step.modifiers), key: cleanString(step.key, 40).toUpperCase() || 'A' }
}

export function normalizeMacro(value) {
  const macro = value && typeof value === 'object' ? value : {}
  const steps = Array.isArray(macro.steps) ? macro.steps.slice(0, 32).map(normalizeStep) : []
  return { schema: MACRO_SCHEMA, name: cleanString(macro.name, 80) || '未命名宏', steps }
}

export function normalizeBinding(value) {
  const binding = value && typeof value === 'object' ? value : {}
  if (binding.type === 'macro') return { type: 'macro', macro: normalizeMacro(binding.macro) }
  if (binding.type === 'text') return { type: 'text', value: cleanString(binding.value) }
  if (binding.type === 'media') return { type: 'media', action: MEDIA_ACTIONS.includes(binding.action) ? binding.action : 'volume_up' }
  return { type: 'combo', modifiers: cleanModifiers(binding.modifiers), key: cleanString(binding.key, 40).toUpperCase() || 'A' }
}

export function normalizeKeymap(value) {
  const source = value && typeof value === 'object' ? value : {}
  return Object.fromEntries(PHYSICAL_KEYS.map((key) => [key.id, normalizeBinding(source[key.id])]))
}

export function validateMacro(value) {
  const macro = normalizeMacro(value)
  const errors = []
  if (!macro.name) errors.push('宏名称不能为空')
  if (!macro.steps.length) errors.push('宏至少需要一个动作')
  macro.steps.forEach((step, index) => {
    if (step.op === 'text' && !step.value) errors.push(`第 ${index + 1} 步文字不能为空`)
    if (step.op === 'combo' && !step.key) errors.push(`第 ${index + 1} 步按键不能为空`)
  })
  return { valid: errors.length === 0, errors, value: macro }
}

export function serializeKeymap(value) {
  return JSON.stringify({ schema: KEYMAP_SCHEMA, keymap: normalizeKeymap(value) })
}

export function loadDraft(storage = globalThis.localStorage) {
  try {
    const value = JSON.parse(storage?.getItem('vibokey:keymap-draft') || 'null')
    return normalizeKeymap(value)
  } catch {
    return createDefaultKeymap()
  }
}

export function saveDraft(value, storage = globalThis.localStorage) {
  const normalized = normalizeKeymap(value)
  storage?.setItem('vibokey:keymap-draft', JSON.stringify(normalized))
  return normalized
}
